import { FC } from 'react';
import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { clsx } from 'clsx';
import { CrossIcon } from 'components/icons/CrossIcon';

export const Badge: FC<{
  name: string;
  onClick?: () => void;
  className?: string;
  cross?: boolean;
}> = ({ name, className, onClick, cross = true }) => (
  <Box
    onClick={onClick}
    className={clsx(
      'flex max-h-9 min-w-max max-w-max cursor-pointer items-center justify-center gap-2 rounded-3xl bg-mult px-3 py-2',
      className
    )}
  >
    <Typography className="text-sm font-medium text-dark">{name}</Typography>
    {cross && <CrossIcon className="h-[11px] w-[11px] text-dark" />}
  </Box>
);
